import types from '@constants/action-types';
import { actionRequestFactory, actionResponseFactory } from '@factories';

export const createAccountRequest = payload =>
  actionRequestFactory(types.CREATE_ACCOUNT_REQUEST, payload);
export const createAccountSuccess = user =>
  actionResponseFactory(types.CREATE_ACCOUNT_SUCCESS, { user });
export const createAccountFailure = error =>
  actionResponseFactory(types.CREATE_ACCOUNT_FAILURE, { error });

export const getAccountRequest = id => actionRequestFactory(types.GET_ACCOUNT_REQUEST, id);
export const getAccountSuccess = org => actionResponseFactory(types.GET_ACCOUNT_SUCCESS, { org });
export const getAccountFailure = error =>
  actionResponseFactory(types.GET_ACCOUNT_FAILURE, { error });

export const updateAccountRequest = (id, payload) =>
  actionRequestFactory(types.UPDATE_ACCOUNT_REQUEST, { id, payload });

export const updateAccountSuccess = org =>
  actionResponseFactory(types.UPDATE_ACCOUNT_SUCCESS, { org });
export const updateAccountFailure = error =>
  actionResponseFactory(types.UPDATE_ACCOUNT_FAILURE, { error });

export const orgStrListRequest = payload =>
  actionRequestFactory(types.ORG_STR_LIST_REQUEST, payload);
export const orgStrListSuccess = entities =>
  actionResponseFactory(types.ORG_STR_LIST_SUCCESS, entities);
export const orgStrListFailure = error =>
  actionResponseFactory(types.ORG_STR_LIST_FAILURE, null, { error });
